import { SelectTypes } from '@nhl/nhl-breakaway-ui';

import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { BroadcastPanelCategory } from './enums';
import { BroadcastPanelData, Country } from './types';

export const OTHER_COUNTRIES_CODE = 'OTHER';

export const NETWORK_LINKS = {
    url: {
        default: 'https://www.nhl.com/info/watch-nhl-zipcode-blackout-lookup?wv=true',
        fr: 'https://www.nhl.com/fr/info/watch-nhl-zipcode-blackout-lookup?wv=true',
    },
    target: '_blank',
};

export const getCountryOptionFromCountry = (country?: Country): SelectTypes.Option<{ value: Country | null }> => ({
    value: country || null,
    key: country?.abbr || '',
    label: country?.name ? parseValueFromLocalizedAttribute(country.name) : '',
});

export const getAreBroadcastersEmptyForAllPanels = (panelsForCountry: Array<BroadcastPanelData>): boolean => {
    const areBroadcastsEmpty = !panelsForCountry?.find((panel) => {
        if (panel.categoryId === BroadcastPanelCategory.regional) {
            // checks if there are any broadcasts between home or away team
            const areHomeTeamBroadcastsNotEmpty = panel.homeTeam?.broadcasters?.length;
            const areAwayTeamBroadcastsNotEmpty = panel.awayTeam?.broadcasters?.length;

            return areHomeTeamBroadcastsNotEmpty || areAwayTeamBroadcastsNotEmpty;
        }

        // checks if there are any broadcasts for the particular panel
        return panel?.broadcasters?.length && panel?.broadcasters.length > 0;
    });

    return areBroadcastsEmpty;
};
